export default __webpack_public_path__ + "static/media/File No. 8.df404114.pdf";